import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import ThemeContext from '../../utils/theming';

const Button = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 4px;
    border: solid 1px #f1f1ee;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 1);

    &:hover {
        background-color: ${({ theme }) => theme.colors.primary};
        path {
            fill: white;
        }
    }
`;

const ShareButton = props => (
    <Button theme={useContext(ThemeContext)} onClick={props.handleClick}>
        {props.children}
    </Button>
);

ShareButton.propTypes = {
    children: PropTypes.object.isRequired,
    handleClick: PropTypes.func
};

export default ShareButton;
